
export class TabObject {

    public static readonly GENERAL_TAB = new TabObject('GENERAL');
    public static readonly INFORMATION_TAB = new TabObject('INFO');
    public static readonly ORDERS_TAB = new TabObject('ORDERS');
    public static readonly DATA_TAB = new TabObject('DATA');
    public static readonly LOCATIONS_TAB = new TabObject('LOCATIONS');
    public static readonly PRODUCT_TAB = new TabObject('PRODUCT');
    public static readonly SERVICE_TAB = new TabObject('SERVICE');
    public static readonly PROCESSES_TAB = new TabObject('PROCESSES');
    public static readonly SITES_TAB = new TabObject('SITES');
    public static readonly BILLING_TAB = new TabObject('BILLING');
    public static readonly DEPENDENCIES_TAB = new TabObject('DEPENDENCIES');


    private constructor(public name: string) {
        this.name = this.name.toLocaleLowerCase().trim();
    }

    public static createWithName(name: string): TabObject {
        switch (name) {
            case this.GENERAL_TAB.name: return this.GENERAL_TAB;
            case this.PRODUCT_TAB.name: return this.PRODUCT_TAB;
            case this.SERVICE_TAB.name: return this.SERVICE_TAB;
            case this.PROCESSES_TAB.name: return this.PROCESSES_TAB;
            case this.SITES_TAB.name: return this.SITES_TAB;
            case this.BILLING_TAB.name: return this.BILLING_TAB;
            case this.DEPENDENCIES_TAB.name: return this.DEPENDENCIES_TAB;
            default: return this.GENERAL_TAB
        }
    }

    public equals(tab: TabObject): boolean {
        return this.name === tab.name;
    }

}
